import { render, staticRenderFns } from "./FieldWorkplace2List.vue?vue&type=template&id=0a6d5c6f&scoped=true&"
import script from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d5c6f",
  null
  
)

export default component.exports